import React, { useState } from 'react';
import { Alert } from '@biome-design-system/ui/Alert';
import { FormattedMessage, useIntl } from '@kyruus/intl';
import { messages } from './messages';

export const SearchHomeFiltersBanner = () => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) return null;

  return (
    <Alert
      data-testid="search-home-filters-banner"
      variant="outlined"
      severity="info"
      closeText="close"
      onClose={() => setIsOpen(false)}
      sx={(theme) => ({
        marginTop: theme.spacing(2)
      })}
    >
      <FormattedMessage
        {...messages.searchHomeFilters}
        values={{
          clearAllFilters: <b>{intl.formatMessage(messages.clearfilters)}</b>
        }}
      />
    </Alert>
  );
};
